export enum CloudConfigTabsEnum {
  'all' = 0,
  'my-cloud' = 1,
  'hubs' = 2,
}

export const cloudConfigTabsByIndex: {
  [Key in number]: string;
} = {
  0: 'all',
  1: 'my-cloud',
  2: 'hubs',
} as const;

export const cloudConfigTabsByKey: {
  [Key in string]: number;
} = {
  all: 0,
  'my-cloud': 1,
  hubs: 2,
} as const;
